export default "__VITE_ASSET__DIynQPY4__"